import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { addPathToQueue } from "../redux/algolia";
import { useDispatch } from "react-redux";

const useTrackPath = () => {
  let pathname = usePathname();
  const dispatch = useDispatch();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      if (pathname === "/") {
        const tab = searchParams.get("tab");
        const query = searchParams.get("query");
        if (tab && query) {
          pathname = "/search";
        }
      }
      dispatch(addPathToQueue(pathname));
    }
  }, [pathname, searchParams]);
};

export default useTrackPath;
